import styled from 'styled-components';
import { size } from '../../layout/helpers';

export const KeyValueListItem = styled.li`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${size(2)};
  font-size: ${(props) => props.theme.font.size.small};

  & + & {
    margin-top: ${size(1)};
  }
`;

export const KeyValueList = styled.ul<{ $separated?: boolean }>`
  list-style: none;
  padding: 0;
  margin: 0;

  ${(props) =>
    props.$separated &&
    `
    ${KeyValueListItem}:not(:first-child) {
      padding-top: ${size(1)};
    }

    ${KeyValueListItem}:not(:last-child) {
      border-bottom: 1px solid var(--c-border-main);
      padding-bottom: ${size(2)};
    }
  `}
`;

export const KeyValueListKey = styled.div`
  flex-shrink: 0;
  color: var(--c-text-muted);
`;

export const KeyValueListValue = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  hyphens: auto;
`;
